import Vue from 'vue';
import Vuetify, { VBottomSheet, VDialog } from 'vuetify/lib';
import { color, status } from '@/theme/tokens';

// Registered globally because ListingManagerModal picks between them with
// <component :is>, which vuetify-loader's tag scan cannot see.
Vue.use(Vuetify, { components: { VBottomSheet, VDialog } });

// Built from src/theme/tokens.js so this and the --s-* custom properties in
// applyTokens.js never drift apart. See OPT-24-spec.md, "Wiring".
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: color.primary,
        secondary: color.secondary,
        accent: color.accent,
        success: status.healthy.fill,
        warning: status.warn.fill,
        error: status.error.fill,
        info: color.primary,
        money: color.money,
      },
    },
  },
});
